module.exports = __webpack_public_path__ + "img/seed-1440.01d74f50.jpg";